import { render, staticRenderFns } from "./EliminaOrigen.vue?vue&type=template&id=17df18e1&scoped=true"
import script from "./EliminaOrigen.vue?vue&type=script&lang=js"
export * from "./EliminaOrigen.vue?vue&type=script&lang=js"
import style0 from "./EliminaOrigen.vue?vue&type=style&index=0&id=17df18e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17df18e1",
  null
  
)

export default component.exports